var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-series my-6",attrs:{"id":"chance-of-winning-chart"}})}
var staticRenderFns = []

export { render, staticRenderFns }